export default __webpack_public_path__ + "static/media/regulatory--bicycle-parking--g1.16ba1f72.png";